import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--books--payrolls--contracts--dashboard`
  }

  doContractsDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-8 pr-1" data-${this.controllerName}-target="list" data-controller="financials--books--payrolls--contracts--index"></div>
                  <div class="col-4 pl-1" data-${this.controllerName}-target="view" data-controller="financials--books--payrolls--contracts--save financials--books--payrolls--contracts--show"></div>
                </div>`

    // this.getControllerByIdentifier("operations--products--clinics--regularizations--show--main").contentTarget.innerHTML = html
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`financials--books--payrolls--dashboard--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`financials--books--payrolls--dashboard--submenu`).dashboardToggleBtn(`CONTRATOS`)

      controller.getControllerByIdentifier(`financials--books--payrolls--contracts--index`).permission = `financial_payroll_contracts`
      controller.getControllerByIdentifier(`financials--books--payrolls--contracts--save`).permission = `financial_payroll_contracts`
      controller.getControllerByIdentifier(`financials--books--payrolls--contracts--show`).permission = `financial_payroll_contracts`

      controller.getControllerByIdentifier(`financials--books--payrolls--contracts--index`).doListHtml()
      controller.getControllerByIdentifier(`financials--books--payrolls--contracts--show`).doViewHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
